import { render } from "./PostCardTickers.vue?vue&type=template&id=12388688&ts=true"
import script from "./PostCardTickers.vue?vue&type=script&lang=ts"
export * from "./PostCardTickers.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__